import { defineStore } from "pinia";
import { ref } from "vue";
import dashboardService from "@/services/super-admin/dashboardService";
import { toast } from "@/utils/toast";

export const useSuperAdminDashboardStore = defineStore(
  "superAdminDashboard",
  () => {
    const loading = ref(false);
    const error = ref(null);

    const filters = ref({
      range: "month",
      year: new Date().getFullYear(),
      date_from: null,
      date_to: null,
    });

    const kpis = ref({});
    const charts = ref({
      companies: null,
      revenue: null,
      plans: null,
      cards: null,
    });
    const lists = ref({
      recent_transactions: [],
      recent_companies: [],
      recent_expired: [],
      renewal_requests: [],
      pending_reviews: [],
      demo_requests: [],
    });

    async function fetchDashboard(extra = {}) {
      loading.value = true;
      error.value = null;

      try {
        const res = await dashboardService.get({
          ...filters.value,
          ...extra,
        });

        const data = res.data || {};

        if (data.filters) {
          filters.value = {
            ...filters.value,
            ...data.filters,
          };
        }

        kpis.value = data.kpis || {};
        charts.value = data.charts || charts.value;
        lists.value = data.lists || lists.value;
      } catch (e) {
        error.value =
          e?.response?.data?.message || e.message || "Failed to load dashboard";
        toast(error.value, "error");
      } finally {
        loading.value = false;
      }
    }

    function setRange(range) {
      filters.value.range = range;
      filters.value.date_from = null;
      filters.value.date_to = null;
      fetchDashboard();
    }

    function setYear(year) {
      filters.value.year = Number(year);
      fetchDashboard();
    }

    function setCustomRange(startMoment, endMoment) {
      filters.value.range = "custom";
      filters.value.date_from = startMoment.format("YYYY-MM-DD");
      filters.value.date_to = endMoment.format("YYYY-MM-DD");
      fetchDashboard();
    }

    return {
      loading,
      error,
      filters,
      kpis,
      charts,
      lists,
      fetchDashboard,
      setRange,
      setYear,
      setCustomRange,
    };
  }
);
